export default __webpack_public_path__ + "static/media/swz721lc.bf6cd7af.ttf";